import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'
import { desktopCSS } from '@measures/responsive'

export interface TitleProps {
  children: string
}

const StyledTitle = styled.div`
  ${({
    theme: {
      colors: { staticWhite },
      typography: {
        headings: {
          large: { bundledCSS: largeHeadingCSS },
          xxxlarge: { bundledCSS: xxxlargeHeadingCSS },
        },
      },
    },
  }) => {
    const textStyle = css`
      ${largeHeadingCSS};
      ${desktopCSS(css`
        ${xxxlargeHeadingCSS};
      `)};
      color: ${staticWhite};
    `

    //! We apply these rules multiple time to override
    //! browser and body styles applying on `strong` and `p` tags.
    return css`
      position: relative;
      ${textStyle};

      > strong,
      > p {
        ${textStyle};
      }

      > p {
        margin: 0;
      }
    `
  }}
`

const Title: FunctionComponent<TitleProps> = ({ children }) => {
  return <StyledTitle dangerouslySetInnerHTML={{ __html: children }} />
}

export default Title
